import VcCalendar from '../vc-calendar';
import MonthCalendar from '../vc-calendar/src/MonthCalendar';
import YearCalendar from '../vc-calendar/src/YearCalendar';
import QuarterCalendar from '../vc-calendar/src/QuarterCalendar';
import createPicker from './createPicker';
import wrapPicker from './wrapPicker';
import RangePicker from './RangePicker';
import WeekPicker from './WeekPicker';
import {
  DatePickerProps,
  MonthPickerProps,
  WeekPickerProps,
  RangePickerProps,
  YearPickerProps,
  QuarterPickerProps,
} from './interface';
import Base from '../base';
import { initDefaultProps } from '../_util/props-util';

const DatePicker = wrapPicker(
  { ...createPicker(VcCalendar, DatePickerProps()), name: 'ADatePicker' },
  DatePickerProps(),
  'date',
);

const MonthPicker = wrapPicker(
  { ...createPicker(MonthCalendar, MonthPickerProps()), name: 'AMonthPicker' },
  MonthPickerProps(),
  'month',
);

const QuarterPicker = wrapPicker(
  {
    ...createPicker(
      QuarterCalendar,
      initDefaultProps(QuarterPickerProps(), {
        format: 'YYYY-[Q]Q',
      }),
    ),
    name: 'AQuarterPicker',
  },
  QuarterPickerProps(),
  'quarter',
);

const YearPicker = wrapPicker(
  {
    ...createPicker(
      YearCalendar,
      initDefaultProps(YearPickerProps(), {
        format: 'YYYY',
      }),
    ),
    name: 'AYearPicker',
  },
  YearPickerProps(),
  'year',
);

Object.assign(DatePicker, {
  RangePicker: wrapPicker(RangePicker, RangePickerProps(), 'date'),
  WeekPicker: wrapPicker(WeekPicker, WeekPickerProps(), 'week'),
  MonthPicker,
  YearPicker,
  QuarterPicker,
});

/* istanbul ignore next */
DatePicker.install = function(Vue) {
  Vue.use(Base);
  Vue.component(DatePicker.name, DatePicker);
  Vue.component(DatePicker.RangePicker.name, DatePicker.RangePicker);
  Vue.component(DatePicker.MonthPicker.name, DatePicker.MonthPicker);
  Vue.component(DatePicker.WeekPicker.name, DatePicker.WeekPicker);
  Vue.component(DatePicker.YearPicker.name, DatePicker.YearPicker);
  Vue.component(DatePicker.QuarterPicker.name, DatePicker.QuarterPicker);
};

export default DatePicker;
